'use client';

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '@/components/ui/AppIcon';
import ScheduleModal from '@/components/ScheduleModal';

const MobileCTASection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const features = [
        "Free project consultation",
        "Custom strategy roadmap",
        "No-obligation proposal",
        "Quick 24-hour response"
    ];

    return (
        <section className="relative py-20 bg-slate-50 overflow-hidden">
            {/* Background Ambience (Matched to Visionary Duo) */}
            <div className="absolute inset-0 z-0 pointer-events-none">
                <div className="absolute -top-20 -left-20 w-80 h-80 bg-indigo-500/10 rounded-full blur-[80px]" />
                <div className="absolute top-1/2 -right-20 w-80 h-80 bg-blue-500/10 rounded-full blur-[80px]" />
                <div className="absolute inset-0 bg-[url('/grid-pattern.svg')] opacity-[0.03]" />
            </div>

            <div className="container mx-auto px-4 relative z-10">

                {/* Visual "Handle" for the Sheet feel */}
                <div className="flex justify-center mb-8">
                    <div className="w-12 h-1.5 bg-slate-800 rounded-full" />
                </div>

                <div className="bg-white rounded-[32px] p-8 shadow-2xl border border-slate-100 relative overflow-hidden">
                    {/* Badge */}
                    <div className="inline-flex items-center space-x-2 px-3 py-1 bg-indigo-50 border border-indigo-100 rounded-full mb-6">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
                        </span>
                        <span className="text-[10px] uppercase font-bold text-indigo-700 tracking-wider">Start Your Journey</span>
                    </div>

                    {/* Headline */}
                    <h2 className="text-4xl font-black text-slate-900 mb-6 leading-[1.1] tracking-tight">
                        Ready to Elevate Your <br />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-600">Digital Presence?</span>
                    </h2>

                    {/* Description */}
                    <p className="text-base text-slate-600 mb-8 leading-relaxed font-medium">
                        Let's transform your vision into a powerful digital ecosystem that drives measurable growth and brand visibility.
                    </p>

                    {/* Action Button - Full Width */}
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="w-full group relative mb-6 overflow-hidden rounded-2xl bg-slate-900 p-[1px]"
                    >
                        <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#E2E8F0_0%,#6366F1_50%,#E2E8F0_100%)]" />
                        <span className="inline-flex h-full w-full cursor-pointer items-center justify-center rounded-2xl bg-slate-900 px-6 py-4 text-base font-bold text-white backdrop-blur-3xl transition-all group-hover:bg-slate-800/90 gap-2">
                            Start Your Project
                            <Icon name="ArrowRightIcon" className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </span>
                    </button>

                    {/* Secondary Action */}
                    <div className="text-center mb-8">
                        <a
                            href="/homepage#ecosystem-showcase"
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('ecosystem-showcase');
                                if (element) {
                                    element.scrollIntoView({ behavior: 'smooth' });
                                } else {
                                    window.location.href = '/homepage#ecosystem-showcase';
                                }
                            }}
                            className="inline-flex items-center text-sm font-semibold text-slate-500 hover:text-indigo-600 transition-colors"
                        >
                            View Our Work
                            <Icon name="ArrowTopRightOnSquareIcon" className="ml-1.5 w-4 h-4" />
                        </a>
                    </div>

                    {/* Features List (Compact) */}
                    <div className="grid grid-cols-1 gap-3 border-t border-slate-100 pt-6">
                        {features.map((item, i) => (
                            <div key={i} className="flex items-center space-x-3">
                                <Icon name="CheckCircleIcon" className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                                <span className="text-sm font-medium text-slate-700">{item}</span>
                            </div>
                        ))}
                    </div>

                    {/* Trust Indicator */}
                    <div className="mt-8 pt-6 border-t border-slate-100 flex flex-col items-center">
                        <div className="flex -space-x-2 mb-2">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center text-[10px] font-bold text-slate-600 overflow-hidden">
                                    {/* Placeholder avatars or initials */}
                                    {['JD', 'AS', 'MK'][i]}
                                </div>
                            ))}
                            <div className="w-8 h-8 rounded-full border-2 border-white bg-slate-900 flex items-center justify-center text-[10px] font-bold text-white">
                                +25
                            </div>
                        </div>
                        <p className="text-xs font-semibold text-slate-500">Trusted by 25+ businesses</p>
                    </div>

                </div>
            </div>

            {/* SCHEDULE MODAL */}
            <ScheduleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </section>
    );
};

export default MobileCTASection;
